module.exports = __webpack_public_path__ + "static/img/56969_0_dzieci na plazy_original_tr.bd339b13.png";